export const useFetchStoreNames = () => {
	return async (stores) => {
		const promises = []
		const results = {}

		for (const store in stores) {
			promises.push(
				fetch(`https://${store}/meta.json`)
					.then((res) => res.json())
					.then((json) => {
						return {
							store,
							name: json?.name || null,
						}
					})
					.catch((err) => {
						console.error(err)
						return {
							store,
							name: null,
						}
					}),
			)
		}

		await Promise.allSettled(promises).then((res) => {
			res.map((result) => {
				results[result.value.store] = result.value.name
			})
		})

		return results
	}
}

export const useFetchMyshopifyDomain = () => {
	return async (store) => {
		return fetch(`https://${store}/meta.json`)
			.then((res) => res.json())
			.then((json) => {
				return json?.myshopify_domain || null
			})
			.catch((err) => {
				console.error(err)
				return null
			})
	}
}
